import { useQuery } from '@tanstack/react-query';
import { getListUpload } from '../../../api/ListUpload/getListUpload';

import { isInProgressStatus as isInProgress } from '../../../utility/listUploadProgress';

export function useGetListUpload(id: string, initialListUpload: any) {
  const getQuery = useQuery({
    queryKey: [ 'get-list-upload', id ],
    queryFn: () => getListUpload(id).then(response => response.data),
    initialData: initialListUpload,
    refetchInterval: (query) => (isInProgress(query.state.data?.status) ? 2000 : false)
  });

  return {
    listUpload: getQuery.data || initialListUpload,
    isLoading: getQuery.isLoading
  };
}
